import type { PortfolioDetail } from '@repo/api-contracts';
import { type ReactElement, useState } from 'react';
import { Link } from 'react-router';
import { storeProductPath } from '@/shared/config';
import { Button, ImageWithFallback } from '@/shared/ui';

interface PortfolioProductCardProps {
  readonly product: PortfolioDetail['products'][number];
  readonly onRetry: () => void;
}

export const PortfolioProductCard = ({
  product,
  onRetry,
}: PortfolioProductCardProps): ReactElement => {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const [attempt, setAttempt] = useState(0);
  return (
    <article className="min-w-0 space-y-3">
      <Link
        to={storeProductPath(product.id)}
        aria-label={product.name}
        className="group block focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-4"
      >
        <div className="aspect-[4/5] overflow-hidden bg-muted/70">
          <ImageWithFallback
            key={`${product.imageUrl}:${attempt}`}
            src={product.imageUrl}
            alt={product.name}
            className="size-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03] motion-reduce:transition-none"
            onError={() => setFailedUrl(product.imageUrl)}
          />
        </div>
        <h3 className="mt-4 text-[15px] font-semibold wrap-anywhere sm:text-base">
          {product.name}
        </h3>
        <p className="mt-1 text-sm text-muted-foreground">
          상품 보기{' '}
          <span
            aria-hidden
            className="inline-block transition-transform group-hover:translate-x-1 motion-reduce:transition-none"
          >
            →
          </span>
        </p>
      </Link>
      {product.imageUrl !== null && failedUrl === product.imageUrl && (
        <Button
          variant="outline"
          size="sm"
          onClick={() => {
            setFailedUrl(null);
            setAttempt((value) => value + 1);
            onRetry();
          }}
        >
          상품 사진 다시 불러오기
        </Button>
      )}
    </article>
  );
};
